var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSubRating5 = function SvgSubRating5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    width: 99.2,
    height: 56,
    rx: 6,
    fill: "var(--default-primary-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.095 35.156a4.676 4.676 0 0 1-1.89-.375 3.479 3.479 0 0 1-1.399-1.125c-.364-.5-.57-1.08-.617-1.742h1.867c.1.432.331.779.696 1.04.364.254.812.382 1.343.382.563 0 1.04-.193 1.43-.578.39-.386.586-.854.586-1.406 0-.589-.193-1.076-.578-1.461-.386-.391-.865-.586-1.438-.586-.37 0-.713.062-1.03.187-.319.12-.569.287-.75.5H46.68l.516-6.195h6.11v1.765H48.86l-.273 2.735c.208-.167.474-.302.796-.406.323-.104.644-.157.961-.157 1.068 0 1.948.334 2.64 1 .694.662 1.04 1.545 1.04 2.649 0 1.052-.38 1.945-1.14 2.68-.761.729-1.69 1.093-2.79 1.093Z",
    fill: "var(--default-text-color)"
  })));
};

export default SvgSubRating5;